import About from "../components/About";
import Navbar from "../components/Navbar";
import MySpace from "../components/MySpace";
import Footer from "../components/Footer"

export default function MySpacePage() {
  return (
    <div>
         <Navbar />
      <MySpace/>
                                <Footer/>
    </div>
  );
}
